import StudyDiscount from "./StudyDiscount";

export default StudyDiscount